import styled from "styled-components";

const ArrowContainer = styled.div`
  display: inline-block;
  transform: ${({ direction }) =>
    `rotate(${direction + 180}deg) translateY(-1px)`};
`;

export default ArrowContainer;
